import React from 'react';

/**
 * EmptyState — estado vacío estándar para listas y secciones sin datos.
 *
 * Props:
 *   icon      string   — emoji o carácter visual (default '📭')
 *   title     string   — título del estado vacío (requerido)
 *   subtitle  string   — descripción adicional
 *   action    node     — botón CTA opcional
 *
 * Uso:
 *   <EmptyState
 *     icon="👥"
 *     title="No hay clientes todavía"
 *     subtitle="Agrega tu primer cliente para empezar"
 *     action={<Link to="/clients/create" className="btn btn-primary btn-sm">+ Nuevo cliente</Link>}
 *   />
 */
const EmptyState = ({ icon = '📭', title, subtitle, action }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
    textAlign: 'center',
  }}>
    <div style={{
      width: 64,
      height: 64,
      borderRadius: '50%',
      backgroundColor: '#F4F6FB',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 26,
      marginBottom: 14,
    }}>
      {icon}
    </div>
    <p style={{
      margin: '0 0 4px',
      fontSize: 15,
      fontWeight: 600,
      color: '#374151',
    }}>
      {title}
    </p>
    {subtitle && (
      <p style={{
        margin: '0 0 16px',
        fontSize: 13,
        color: '#9CA3AF',
        maxWidth: 280,
      }}>
        {subtitle}
      </p>
    )}
    {action && <div>{action}</div>}
  </div>
);

export default EmptyState;
